import styles from './footer.module.css';

export const Footer = () => <div className={styles.footer}>Created with love</div>;
